"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomTag = void 0;
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _getStyles = require("../helper/getStyles.js");
var _defaultTheme = require("../../../../theme/defaultTheme/index.js");
require("./styles.css");
const _excluded = ["color", "gutterBottom", "noWrap", "variant", "theme", "fontSize", "fontStyle", "fontWeight", "fontFamily", "textAlign", "maxWidth", "display", "lineHeight", "textTransformation", "letterSpacing", "boxShadow", "shadowType", "shadowBlurValue", "shadowColor", "textShadow", "textDecoration", "wordSpacing"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const CustomTag = exports.CustomTag = _styledComponents.default.p`
	${_ref => {
  let {
      color,
      gutterBottom,
      noWrap,
      variant,
      theme,
      fontSize,
      fontStyle,
      fontWeight,
      fontFamily,
      textAlign,
      maxWidth,
      display,
      lineHeight,
      textTransformation,
      letterSpacing,
      boxShadow,
      shadowType,
      shadowBlurValue,
      shadowColor,
      textShadow,
      textDecoration,
      wordSpacing
    } = _ref,
    props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
  const style = (0, _getStyles.getTypographyStyle)(variant, theme);
  const styledFontSize = fontSize ? fontSize : style.fontSize ?? '';
  const styledFontWeight = fontWeight ? fontWeight : style.fontWeight ?? '';
  return (0, _styledComponents.css)`
			color: ${color};
			font-family: ${fontFamily ? fontFamily : theme.typography.fontFamily};
			${gutterBottom ? 'margin-bottom: 1em' : ''};
			${styledFontSize ? `font-size:${styledFontSize}` : ''};
			${styledFontWeight ? `font-weight:${styledFontWeight}` : ''};
			${lineHeight ? `line-height:${lineHeight ? lineHeight : style.lineHeight}` : ''};
			${fontStyle ? `font-style:${fontStyle}` : ''};
			${textAlign ? `text-align:${textAlign}` : ''};
			${wordSpacing ? `word-spacing:${wordSpacing}px` : ''};
			${textTransformation ? `text-transform:${textTransformation}` : 'none'};
			${textDecoration ? `text-decoration:${textDecoration == 'strike_of' ? 'line-through' : textDecoration == 'underline_overline' ? 'underline overline' : textDecoration}` : 'none'};

			${shadowType && (shadowType == 'innerShadow' || shadowType == 'dropShadow') && boxShadow ? `box-shadow:${boxShadow}` : ''};

			${shadowType && shadowType == 'layerBlur' && shadowBlurValue ? `filter:blur(${shadowBlurValue}px)` : ''};

			${shadowType && shadowType == 'backgroundBlur' && shadowBlurValue && shadowColor ? `backdrop-filter:blur(${shadowBlurValue}px); background-color:${shadowColor}` : ''};

			${shadowType && shadowType == 'none' ? `backdrop-filter:none; filter:none` : ''};

			${maxWidth ? `
				max-width: ${maxWidth};
			` : ''};
			${textShadow ? `text-shadow:${textShadow}` : ''};
			letter-spacing: ${letterSpacing};
			overflow: hidden;
			text-overflow: ellipsis;
			${noWrap ? 'white-space: nowrap' : ''};
			display: ${display};
			&.typography__title1 {
				margin: 0;
				font-size: 60px;
				line-height: ${lineHeight ? lineHeight : '72px'};
				font-weight: 700;
			}

			&.typography__title2 {
				margin: 0;
				font-size: 48px;
				line-height: ${lineHeight ? lineHeight : '56px'};
				font-weight: 700;
			}

			&.typography__title3 {
				margin: 0;
				font-size: 34px;
				line-height: ${lineHeight ? lineHeight : '40px'};
				font-weight: 800;
			}

			&.typography__headline {
				margin: 0;
				font-size: 24px;
				line-height: ${lineHeight ? lineHeight : '32px'};
				font-weight: 800;
			}

			&.typography__headline1 {
				margin: 0;
				font-size: 20px;
				line-height: ${lineHeight ? lineHeight : '30px'};
				font-weight: 600;
			}

			&.typography__subheadline {
				margin: 0;
				font-size: 18px;
				line-height: ${lineHeight ? lineHeight : '24px'};
				font-weight: 700;
			}

			&.typography__body {
				margin: 0;
				font-size: 16px;
				line-height: ${lineHeight ? lineHeight : '24px'};
				font-weight: 400;
			}

			&.typography__body-bold {
				margin: 0;
				font-size: 16px;
				line-height: ${lineHeight ? lineHeight : '24px'};
				font-weight: 700;
			}

			&.typography__body-small {
				margin: 0;
				font-size: 14px;
				line-height: ${lineHeight ? lineHeight : '16px'};
				font-weight: 400;
			}

			&.typography__body-small-bold {
				margin: 0;
				font-size: 14px;
				line-height: ${lineHeight ? lineHeight : '16px'};
				font-weight: 700;
			}

			&.typography__small-light {
				margin: 0;
				font-size: 14px;
				line-height: ${lineHeight ? lineHeight : '16px'};
				font-weight: 700;
			}

			&.typography__caption {
				margin: 0;
				font-size: 12px;
				line-height: ${lineHeight ? lineHeight : '16px'};
				font-weight: 600;
			}

			&.typography__caption-light {
				margin: 0;
				font-size: 12px;
				line-height: ${lineHeight ? lineHeight : '16px'};
				font-weight: 400;
			}

			&.typography__button-large {
				margin: 0;
				font-size: 16px;
				line-height: ${lineHeight ? lineHeight : '24px'};
				font-weight: 700;
			}

			&.typography__button-medium {
				margin: 0;
				font-size: 14px;
				line-height: ${lineHeight ? lineHeight : '16px'};
				font-weight: 700;
			}

			&.typography__button-small {
				margin: 0;
				font-size: 12px;
				line-height: ${lineHeight ? lineHeight : '16px'};
				font-weight: 700;
			}

			&.typography__align-inherit {
				text-align: start;
			}

			&.typography__align-center {
				text-align: center;
			}

			&.typography__align-justify {
				text-align: justify;
			}

			&.typography__align-left {
				text-align: left;
			}

			&.typography__align-right {
				text-align: right;
			}

			&.typography__headline-2 {
				margin: 0;
				font-size: 20px;
				line-height: ${lineHeight ? lineHeight : '116%'};
				font-weight: 700;
			}

			&.typography__body-semibold {
				margin: 0;
				font-size: 16px;
				line-height: ${lineHeight ? lineHeight : '24px'};
				font-weight: 600;
			}

			&.typography__caption-light {
				margin: 0;
				font-size: 12px;
				line-height: ${lineHeight ? lineHeight : '16px'};
				font-weight: 400;
			}

			&.typography__caption-small {
				margin: 0;
				font-size: 8px;
				line-height: ${lineHeight ? lineHeight : '8px'};
				font-weight: 600;
			}
		`;
}}
`;
CustomTag.defaultProps = {
  theme: _defaultTheme.theme
};